export default __webpack_public_path__ + "media/images/images/raty/star-on-611c5fac55ad7c6d3c19690e40e51888.png";